import {
  type EFeatureFlag,
  isCustomerVisibleFeatureFlag,
} from '@mahawi/eshop-common/dist/src/types';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function FeatureFlags({
  featureFlags,
  stock,
}: {
  featureFlags: EFeatureFlag[];
  stock: number;
}): React.JSX.Element | null {
  const { t } = useTranslation();

  if (!stock) return null;

  const visibleFlags = (featureFlags ?? []).filter(
    (flag: EFeatureFlag): boolean =>
      isCustomerVisibleFeatureFlag(flag) &&
      t(`product.featureFlag.${flag}`, { defaultValue: '' }) !== '',
  );

  if (!visibleFlags.length) return null;

  return (
    <ul className="feature-flags">
      {visibleFlags.map((flag: EFeatureFlag): React.JSX.Element => (
        <li key={flag} className={`feature-flag feature-flag--${flag}`}>
          {t(`product.featureFlag.${flag}`)}
        </li>
      ))}
    </ul>
  );
}
